import React from 'react'
import styles from "./Admin.module.css"

import Table from '../../../Components/Admin/DataTable/Table';

import { useContext } from "react";
import { RootContext } from "../../../context/RootProvider";



function Admin() {
    const rootContext = useContext(RootContext);
  return (
          <div className={styles.adminContainer}>
            <div className={styles.adminText}>Bun venit, {rootContext.user.firstName}</div>

            <Table />        
          </div>
  )
}

export default Admin
